import React, { ReactNode } from 'react';

export interface TabItem {
  id?: string | number;
  label: string;
  path?: string;
  icon?: ReactNode;
  img?: string;
}

interface TabsProps<T> {
  tabs: TabItem[];
  activeTab: T;
  onTabChange: (id: T) => void;
  showIcons?: boolean;
  className?: string;
  ActivetabClassName?: string;
  InActivetabClassName?: string;
  variant?: 'pill' | 'underline';
}

export const Tabs: React.FC<TabsProps<any>> = ({
  tabs,
  activeTab,
  onTabChange,
  showIcons = false,
  className = 'flex gap-1 bg-green3 rounded-xl p-1 w-fit',
  ActivetabClassName = '',
  InActivetabClassName = '',
  variant = 'pill',
}) => {
  return (
    <div
      className={`
        overflow-x-auto scrollbar-hide
        w-full
      `}
    >
      <div
        className={`
          ${className}
          min-w-full sm:min-w-max
    flex-nowrap
        `}
      >
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;

          return (
            <button
              type="button"
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                 px-3 sm:px-4
  py-2
  text-xs sm:text-sm
  flex items-center justify-center gap-2
  rounded-lg
  transition-all
  capitalize
  whitespace-nowrap
  flex-shrink-0
  flex-1 sm:flex-initial

                ${
                  variant === 'pill'
                    ? isActive
                      ? `bg-header border border-black text-textcolor shadow-sm ${ActivetabClassName}`
                      : `text-gray-700 bg-light border border-black ${InActivetabClassName}`
                    : isActive
                      ? `bg-white border-b-2 border-green3 font-semibold text-green3`
                      : `text-textcolor hover:text-green3`
                }
              `}
            >
              {showIcons && tab.icon && (
                <span className="inline-flex items-center">{tab.icon}</span>
              )}

              {showIcons && tab.img && <img src={tab.img} alt="" />}

              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
